import { type RouteRecordRaw } from 'vue-router'

import { type AuthZFn } from '@/vue-router'

const canAccessInbox: AuthZFn = ({ user }) => user.can('read', 'inbox.thread')

export const inboxRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/InboxView.vue'),
    meta: {
      authZ: canAccessInbox,
      title: 'inbox',
    },
    name: 'brand.inbox',
    path: 'inbox',
  },
]
